import { uiText } from '../../i18n/uiText';
import React from 'react';

// Presentation only. Counts, navigation and permissions stay with the screen.
export function StatStrip({ items, label = uiText("Сводка") }) {
  return <div className="ap-stat-strip" role="group" aria-label={label}>
    {items.map(item => {
      const Tag = item.onClick ? 'button' : 'div';
      return <Tag key={item.key || item.label} className={`ap-stat-strip__item ${item.active ? 'is-active' : ''}`} type={item.onClick ? 'button' : undefined} onClick={item.onClick} aria-pressed={item.onClick ? Boolean(item.active) : undefined} aria-controls={item.controls}>
        <strong className={item.tone ? `ap-tone-${item.tone}` : undefined}>{item.value}</strong><span>{item.label}</span>
      </Tag>;
    })}
  </div>;
}

// Native disclosure keeps children mounted: opening/closing never clears an
// editor or restarts its requests. Each disclosure is independently operable.
export function Disclosure({ title, hint, children, disabled = false, ...props }) {
  if (disabled) return <>{children}</>;
  return <details className="ap-disclosure" {...props}>
    <summary><span>{title}</span>{hint && <small>{hint}</small>}</summary>
    <div className="ap-disclosure__body">{children}</div>
  </details>;
}
